<template>
  <div>
    <transition name="slide">
      <div
        v-if="isOpened"
        class="drawer-panel"
        ref="drawer"
      >
        <drawer-inner
          :title="title"
          @close="close"
        >
          <slot />
        </drawer-inner>
      </div>
    </transition>

    <transition name="fade-slow">
      <div
        v-if="isOpened"
        class="drawer-panel__overlay"
        @click="close"
      />
    </transition>
  </div>
</template>

<script>
import DrawerInner from './drawer-inner.vue'

export default {
  name: 'drawer-panel',

  components: {
    DrawerInner
  },

  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '',
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss">
  @import "./common.scss";

  .drawer-panel {
    @include panel;

    &__overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $overlay;
      z-index: 100;
    }
  }
</style>
